import { isPlatformServer, PlatformLocation } from '@angular/common';
import { InjectionToken, makeStateKey, PLATFORM_ID, TransferState } from '@angular/core';

export const INITIAL_SESSION_GUID_TOKEN = new InjectionToken<string>('InitialSessionGUID');

export const initialSessionGuid = makeStateKey<string>('InitialSessionGUID');

export function generateGuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function provideInitialSessionGuid() {
  return [
    {
      provide: INITIAL_SESSION_GUID_TOKEN,
      useFactory: (platformId: PlatformLocation, transferState: TransferState) => {
        if (isPlatformServer(platformId)) {
          // Server-side: Generate GUID and store it in TransferState
          const guid = generateGuid();
          transferState.set(initialSessionGuid, guid);
          return guid;
        } else {
          // Client-side: Retrieve GUID from TransferState
          return transferState.get(initialSessionGuid, '');
        }
      },
      deps: [PLATFORM_ID, TransferState]
    }
  ];
}
